import Cookies from "universal-cookie";

const cookies = new Cookies();

const token = cookies.get("__token");

const API_PREFIX = "/admin";
const header = {
  Accept: "application/json",
  "Content-Type": "application/json",
  Authorization: token && `Bearer ${token}`,
  "access-control-allow-origin": "*",
};
const fallback = (error) => {
  console.log("Fetch request error", error);
  if (error.status === 401) {
    cookies.remove("__token", {
      path: "/",
    });
    window.location.href = "/auth/login";
  }
};

const Fetch = {
  get: (endpoint, callback, failed = fallback) => {
    fetch(process.env.REACT_APP_URL + API_PREFIX + endpoint, {
      method: "GET",
      headers: header,
    })
      .then((response) => {
        if (response.status >= 300) failed && failed(response);
        return response.json();
      })
      .catch((response) => (failed ? failed(response) : fallback))
      .then((response) => callback(response));
  },
  post: (endpoint, data, callback, failed = fallback) => {
    fetch(process.env.REACT_APP_URL + API_PREFIX + endpoint, {
      method: "POST",
      body: JSON.stringify(data),
      headers: header,
    })
      .then((response) => {
        return response.json();
      })
      .catch((response) => (failed ? failed(response) : fallback))
      .then((response) => callback(response));
  },
  put: (endpoint, data, callback, failed = fallback) => {
    fetch(process.env.REACT_APP_URL + API_PREFIX + endpoint, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: header,
    })
      .then((response) => {
        if (response.status >= 300) failed && failed(response);
        return response.json();
      })
      .catch((response) => (failed ? failed(response) : fallback))
      .then((response) => callback(response));
  },

  delete: (endpoint, callback, failed = fallback) => {
    fetch(process.env.REACT_APP_URL + API_PREFIX + endpoint, {
      method: "DELETE",
      headers: header,
    })
      .then((response) => {
        if (response.status >= 300) failed && failed(response);
        return response.json();
      })
      .catch((response) => (failed ? failed(response) : fallback))
      .then((response) => callback(response));
  },
  check: (token, callback, failed = fallback) => {
    fetch(process.env.REACT_APP_URL + "/admin/check", {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token && `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.status >= 300) failed && failed(response);
        return response.json();
      })
      .then((response) => callback(response));
  },
};

// Object.freeze(Fetch);

export default Fetch;
